import scrollTo from 'scroll-to';

export default class ScrollTo {
    constructor(padding = 100) {
        this.padding = padding;
        this.controllers();
    }


    onHash() {
        const url = document.URL;
        const hash = url.split('#')[1];
        const el = document.getElementById(hash);
        if (el) {
            const top = el.offsetTop - this.padding;
            scrollTo(0, top, {
                ease: 'out-sine',
                duration: 1500
            });
        }
    }

    controllers() {
        this.onHash();
        window.addEventListener('hashchange', e => this.onHash());
    }
}


// WEBPACK FOOTER //
// ./modules/ScrollTo/index.js